/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountSegnalato } from './account-segnalato';
import { Evento } from './evento';
import { Segnalante } from './segnalante';


export interface SegnalazioneAccountDTO { 
    id?: string;
    version?: number;
    riferimento?: string;
    stato?: SegnalazioneAccountDTOStatoEnum;
    esito?: SegnalazioneAccountDTOEsitoEnum;
    provider?: SegnalazioneAccountDTOProviderEnum;
    created_at?: string;
    chiusa_at?: string;
    chiusa_da?: string;
    segnalante?: Segnalante;
    account_segnalato?: AccountSegnalato;
    eventi?: Array<Evento>;
}
export enum SegnalazioneAccountDTOStatoEnum {
    APERTA = 'APERTA',
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    CHIUSA = 'CHIUSA'
};
export enum SegnalazioneAccountDTOEsitoEnum {
    ACCOUNT_ABUSIVO_ANONIMIZZATO = 'ACCOUNT_ABUSIVO_ANONIMIZZATO',
    NESSUN_ABUSO = 'NESSUN_ABUSO',
    RITIRATA_DAL_SEGNALANTE = 'RITIRATA_DAL_SEGNALANTE',
    ALTRO = 'ALTRO'
};
export enum SegnalazioneAccountDTOProviderEnum {
    SPID = 'SPID',
    CIE = 'CIE'
};



